import { createAction } from '@reduxjs/toolkit';

export const getPermissions = createAction<string>('permissions/getPermissions');
